/**
 * Contact Page
 */

import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactSection from '../components/sections/ContactSection';

const ContactPage = () => {
  return (
    <>
      <Header />
      
      <main style={{ marginTop: '80px', minHeight: '80vh' }}>
        <ContactSection title="Contact Us" />
      </main>

      <Footer />
    </>
  );
};

export default ContactPage;
